import { C } from "../../lib/colors";

export const IllustrationPipeline = () => (
  <svg viewBox="0 0 320 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{width:"100%",height:"100%"}}>
    <rect width="320" height="200" rx="16" fill="#0C0F1A"/>
    {[
      {x:20,y:80,label:"Prospect",color:C.green,icon:"◎"},
      {x:80,y:60,label:"Strategy",color:C.blue,icon:"◈"},
      {x:140,y:85,label:"Write",color:C.amber,icon:"✍"},
      {x:200,y:60,label:"Review",color:C.cyan,icon:"◉"},
      {x:260,y:80,label:"Deliver",color:C.purple,icon:"↗"},
    ].map((s,i)=>(
      <g key={i}>
        {i<4 && <path d={`M${s.x+28},${s.y+14} Q${s.x+44},${s.y+14} ${s.x+58},${[80,60,85,60,80][i+1]+14}`}
          stroke={`rgba(255,255,255,0.1)`} strokeWidth="1.5" strokeDasharray="4,3" fill="none"/>}
        <rect x={s.x} y={s.y} width="28" height="28" rx="8" fill={`${s.color}18`} stroke={`${s.color}40`} strokeWidth="1.5"/>
        <text x={s.x+14} y={s.y+18} textAnchor="middle" fontSize="11" fill={s.color}>{s.icon}</text>
        <text x={s.x+14} y={s.y+44} textAnchor="middle" fontSize="7" fill="rgba(255,255,255,0.4)" fontFamily="monospace">{s.label}</text>
      </g>
    ))}
    <rect x="60" y="130" width="200" height="36" rx="10" fill="rgba(255,255,255,0.03)" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
    <rect x="72" y="140" width="176" height="5" rx="2.5" fill="rgba(255,255,255,0.06)"/>
    <rect x="72" y="140" width="132" height="5" rx="2.5" fill="url(#pg1)"/>
    <text x="160" y="158" textAnchor="middle" fontSize="8" fill="rgba(255,255,255,0.3)" fontFamily="monospace">PIPELINE 75% COMPLETE</text>
    <defs><linearGradient id="pg1" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stopColor={C.green}/><stop offset="100%" stopColor={C.blue}/></linearGradient></defs>
  </svg>
);
